import { createFileRoute } from "@tanstack/react-router";
import { Shell } from "~/components/site-shell";
import { ContentCard, getContentSections } from "~/components/content";
import { breadcrumbs, jsonLd, seoHead } from "~/config/seo";
export const Route = createFileRoute("/knowledge-base/")({
  head: () => ({
    ...seoHead({
      title: "Help Centre | HostRight",
      description: "Useful, practical HostRight guides.",
      path: "/knowledge-base",
    }),
    scripts: [
      jsonLd(
        breadcrumbs([
          { name: "Home", path: "/" },
          { name: "Help Centre", path: "/knowledge-base" },
        ]),
      ),
    ],
  }),
  component: () => (
    <Shell>
      <section className="bg-ink text-cream">
        <div className="mx-auto max-w-7xl px-5 py-20 lg:px-12">
          <p className="eyebrow text-leaf">Help centre</p>
          <h1 className="display mt-4 text-6xl font-bold">
            Answers without the runaround.
          </h1>
          <p className="mt-5 max-w-xl text-lg leading-8 text-cream/65">
            Organised guides for getting started, caring for a website, choosing
            a service, and comparing your options.
          </p>
        </div>
      </section>
      <div className="mx-auto max-w-7xl px-5 py-16 lg:px-12">
        {Object.entries(getContentSections()).map(([id, section]) => {
          const items =
            id === "application-hosting"
              ? section.items.filter((item) => item.slug.split("/").length <= 2)
              : section.items;
          return (
            <section
              id={id}
              key={id}
              className="scroll-mt-24 border-b border-ink/10 py-12 first:pt-0 last:border-0"
            >
              <p className="eyebrow text-moss">Help centre</p>
              <h2 className="display mt-3 text-4xl font-bold">
                {section.label}
              </h2>
              <div className="mt-8 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
                {items.map((item) => (
                  <ContentCard
                    key={item.slug}
                    item={item}
                    kind="knowledge-base"
                  />
                ))}
              </div>
            </section>
          );
        })}
      </div>
    </Shell>
  ),
});
